export type LfdColourOption = { label: string; codes: string[] };

export const LFD_COLOUR_OPTIONS: LfdColourOption[] = [
  { label: 'Green', codes: ['g'] },
  { label: 'Yellow', codes: ['y'] },
  { label: 'Red', codes: ['r'] }
];
